export default {
  data() {
    return {
      raceEnglishWord: null, // 英文
      raceChineseWord: null, // 中文
      raceVocabulary: [], // 抢答模式限定的词表（按词量限定抽取）

      raceEnglishslice: null, // 英文切片
      raceHasCheckedType: null, // 是否已检查
      playerBothRoundsPlayed: 0,
      wordPosition: 1, // 1上 -1下
      // 分数动画相关
      player1ScoreAnimation: {
        show: false,
        value: "",
        type: "", // 'correct' 或 'incorrect'
        source: "", // 'button' 或 'keyboard'
      },
      player2ScoreAnimation: {
        show: false,
        value: "",
        type: "", // 'correct' 或 'incorrect'
        source: "", // 'button' 或 'keyboard'
      },
      // 动画定时器ID
      player1AnimationTimer: null,
      player2AnimationTimer: null,
      // 延迟回调定时器ID
      raceDelayTimer: null,
      // 防止重复点击的全局标志（任意一方点击后双方都锁定）
      gameClickLocked: false,
      // 当前题目是否已被处理（防止同一题被重复提交）
      currentRoundProcessed: false,
    };
  },
  methods: {
    raceStartGame() {
      // 重置玩家数据
      this.raceResetPlayerData();
      this.resetPlayerData();
      this.letterResetPlayerData();
      // 完全重置动画状态
      this.resetAnimationState();
      this.gameState = "playing";
      this.optionsPanelVisible = false;
      this.raceHasCheckedType = null;
      this.playerBothRoundsPlayed = 0;
      this.questions = []; // Reset questions

      // Init restricted vocabulary
      const shuffled = [...this.vocabulary].sort(() => 0.5 - Math.random());
      this.raceVocabulary = shuffled.slice(0, Math.min(this.questionCount, shuffled.length));

      this.setupPlayWord();

      if (this.selectedGameMode === "timeLimit") {
        this.remainingTime = this.timeLimit;
        this.startTimeLimitTimer();
      }
    },
    raceResetPlayerData() {
      this.player1DisplayWord = "";
      this.player2DisplayWord = "";
      this.player1Selections = {};
      this.player2Selections = {};
      this.raceEnglishWord = null;
      this.raceChineseWord = null;
      this.raceEnglishslice = null;
      this.raceHasCheckedType = null;
      this.player1SelectedPosition = null;
      this.player2SelectedPosition = null;
      this.player1AnswerSubmitted = false;
      this.player2AnswerSubmitted = false;
      // 清除倒计时和延迟定时器
      this.initClearTimer();
      this.clearRaceDelayTimer();
    },
    // 完全重置动画状态（只在游戏重新开始时调用）
    resetAnimationState() {
      this.clearScoreAnimationTimers();
      this.player1ScoreAnimation = { show: false, value: "", type: "", source: "" };
      this.player2ScoreAnimation = { show: false, value: "", type: "", source: "" };
      this.gameClickLocked = false;
      this.currentRoundProcessed = false;
    },
    // 清除延迟回调定时器
    clearRaceDelayTimer() {
      if (this.raceDelayTimer) {
        clearTimeout(this.raceDelayTimer);
        this.raceDelayTimer = null;
      }
    },
    // 清除分数动画定时器
    clearScoreAnimationTimers() {
      if (this.player1AnimationTimer) {
        clearTimeout(this.player1AnimationTimer);
        this.player1AnimationTimer = null;
      }
      if (this.player2AnimationTimer) {
        clearTimeout(this.player2AnimationTimer);
        this.player2AnimationTimer = null;
      }
    },
    setupPlayWord() {
      // 随机从vocabulary中取单词（优先使用词量限定抽取的词表）
      const vocab = this.raceVocabulary && this.raceVocabulary.length > 0 ? this.raceVocabulary : this.vocabulary;
      const randomIndex = Math.floor(Math.random() * vocab.length);
      const selectedWord = vocab[randomIndex].english;
      this.player1Word = selectedWord;
      this.player2Word = selectedWord;
      this.raceChineseWord = vocab[randomIndex].chinese;

      // Populate questions array for display purposes if empty
      if (this.questions.length === 0) {
        // 按词量限定显示题目总数
        const actualCount = Math.min(this.questionCount, vocab.length);
        this.questions = new Array(actualCount).fill({});
      }
      // 将单词转换为字符数组
      let wordArray;
      if (this.playerBothRoundsPlayed % 2 === 0) {
        wordArray = selectedWord.split("");
      } else {
        wordArray = selectedWord.split("");
        // 随机决定要替换的字母数量（1-2个）
        const numLettersToReplace = Math.floor(Math.random() * 2) + 1;
        // 创建可用位置的数组（排除空格）
        const availablePositions = [];
        for (let i = 0; i < wordArray.length; i++) {
          if (wordArray[i] !== " ") {
            availablePositions.push(i);
          }
        }
        // 随机选择要替换的位置
        const positionsToReplace = [];
        for (let i = 0; i < numLettersToReplace && availablePositions.length > 0; i++) {
          const randomPosIndex = Math.floor(Math.random() * availablePositions.length);
          const position = availablePositions.splice(randomPosIndex, 1)[0];
          positionsToReplace.push(position);
        }
        // 替换选定的字母
        for (const position of positionsToReplace) {
          // 生成一个不同于原字母的随机字母
          let newLetter;
          do {
            newLetter = String.fromCharCode(97 + Math.floor(Math.random() * 26)); // 97是'a'的ASCII码
          } while (newLetter === wordArray[position]);
          wordArray[position] = newLetter;
        }
      }
      this.player1DisplayWord = wordArray;
      this.player2DisplayWord = wordArray;
      // 将修改后的单词赋值给raceEnglishWord
      this.raceEnglishWord = wordArray.join("");
    },
    initClearTimer() {
      clearInterval(this.answerCountNumberInterval);
      this.answerCountNumberInterval = null;
    },
    racePlayerData(player) {
      // 每次开始抢答/切换玩家时，重置单词显示状态
      this.resetDisplayWord();
      this.isShowDes = false;
      this.raceHasCheckedType = player;
      this.answerCountNumber = 15;
      this.initClearTimer();
      this.answerCountNumberInterval = setInterval(() => {
        if (this.answerCountNumber > 0) {
          this.answerCountNumber--;
        } else {
          this.initClearTimer();
          const isPlayer1 = this.raceHasCheckedType === "1";
          const otherPlayerSubmitted = isPlayer1 ? this.player2AnswerSubmitted : this.player1AnswerSubmitted;

          if (otherPlayerSubmitted) {
            this.submitAnswer(parseInt(this.raceHasCheckedType));
          } else {
            if (this.raceHasCheckedType === "2") {
              this.player2SelectedPosition = null;
              this.player2AnswerSubmitted = false;
            } else {
              this.player1SelectedPosition = null;
              this.player1AnswerSubmitted = false;
            }
            this.racePlayerData(this.raceHasCheckedType === "1" ? "2" : "1");
          }
        }
      }, 1000);
    },
    // 重置单词显示状态
    resetDisplayWord() {
      // 恢复原始的 raceEnglishWord 到 displayWord
      // 注意：raceEnglishWord 已经是被修改过的带错误字母的单词（在 setupPlayWord 中设置）
      // 所以我们只需要将字符串重新分割为数组即可
      if (this.raceEnglishWord) {
        const wordArray = this.raceEnglishWord.split("");
        this.player1DisplayWord = [...wordArray];
        this.player2DisplayWord = [...wordArray];
        // 清除玩家的选择记录
        this.player1Selections = {};
        this.player2Selections = {};
      }
    },
    // 处理键盘字母点击
    handleRaceClick(player, letter) {
      console.log("点击字母:", player, letter);

      if (player === 1) {
        if (this.player1SelectedPosition === null || this.player1AnswerSubmitted) {
          console.log("玩家1未选择位置或已提交答案");
          return;
        }

        // 直接更新选择
        this.player1Selections = {
          ...this.player1Selections,
          [this.player1SelectedPosition]: letter,
        };
        this.player1DisplayWord[this.player1SelectedPosition] = letter;
      } else {
        if (this.player2SelectedPosition === null || this.player2AnswerSubmitted) {
          console.log("玩家2未选择位置或已提交答案");
          return;
        }
        // 直接更新选择
        this.player2Selections = {
          ...this.player2Selections,
          [this.player2SelectedPosition]: letter,
        };
        this.player2DisplayWord[this.player2SelectedPosition] = letter;
      }
    },
    refreshRaceWord() {
      this.raceResetPlayerData();
      this.setupPlayWord();
      // 新题目加载完成后，重置锁定状态
      this.currentRoundProcessed = false;
      this.gameClickLocked = false;
    },
    // 改变位置
    changePosition(num) {
      if (num === this.wordPosition) return;
      this.wordPosition = num;
      let englishWord = this.raceEnglishWord;
      let chineseWord = this.raceChineseWord;
      this.raceEnglishWord = chineseWord;
      this.raceChineseWord = englishWord;
    },
    // 检查是否可以点击（防止重复点击，全局锁定 + 当前题目未被处理）
    canPlayerClick() {
      return !this.gameClickLocked && !this.currentRoundProcessed;
    },
    // 标记当前题目已被处理
    markCurrentRoundProcessed() {
      this.currentRoundProcessed = true;
    },
    // 锁定点击（全局锁定，双方都不能操作）
    lockGameClick() {
      this.gameClickLocked = true;
    },
    // 解锁点击
    unlockGameClick() {
      this.gameClickLocked = false;
    },
    // 显示分数动画
    showScoreAnimation(player, isCorrect) {
      // 如果已锁定或当前题目已处理，不再触发新动画
      if (!this.canPlayerClick()) {
        return;
      }

      // 标记当前题目已被处理（核心防重复逻辑）
      this.markCurrentRoundProcessed();
      // 全局锁定点击（双方都不能操作）
      this.lockGameClick();

      this.triggerScoreAnimation(player, isCorrect);
    },
    // 确认按钮提交时显示分数动画（不检查锁定状态）
    showConfirmScoreAnimation(player, isCorrect) {
      this.triggerScoreAnimation(player, isCorrect, "keyboard");
    },
    // 触发分数动画的实际逻辑
    triggerScoreAnimation(player, isCorrect, source = "button") {
      console.log("触发分数动画:", player, isCorrect, source);
      const animationData = {
        show: true,
        value: isCorrect ? "+1" : "-1",
        type: isCorrect ? "correct" : "incorrect",
        source: source,
      };

      // 动画显示时间（与 CSS 动画时间匹配）1.5s
      const animationDuration = 1500;

      if (player === 1) {
        // 先清除之前的定时器
        if (this.player1AnimationTimer) {
          clearTimeout(this.player1AnimationTimer);
        }
        this.player1ScoreAnimation = { ...animationData };
        console.log("player1ScoreAnimation 已设置:", this.player1ScoreAnimation);
        // 动画结束后隐藏并解锁
        this.player1AnimationTimer = setTimeout(() => {
          this.player1ScoreAnimation = { show: false, value: "", type: "", source: "" };
          this.player1AnimationTimer = null;
          this.unlockGameClick();
        }, animationDuration);
      } else {
        // 先清除之前的定时器
        if (this.player2AnimationTimer) {
          clearTimeout(this.player2AnimationTimer);
        }
        this.player2ScoreAnimation = { ...animationData };
        console.log("player2ScoreAnimation 已设置:", this.player2ScoreAnimation);
        // 动画结束后隐藏并解锁
        this.player2AnimationTimer = setTimeout(() => {
          this.player2ScoreAnimation = { show: false, value: "", type: "", source: "" };
          this.player2AnimationTimer = null;
          this.unlockGameClick();
        }, animationDuration);
      }
    },
  },
  beforeDestroy() {
    // 组件销毁时清除所有定时器
    this.resetAnimationState();
    this.clearRaceDelayTimer();
    this.initClearTimer();
  },
  mounted() {},
};
